import { isMobile } from "components/ReactUtils/mobileDetect.js";
import { Provider } from "mobx-react";
import { t } from "translations/i18n";
import GoogleTagManager from "components/Tracking/GoogleTagManager";
import Helmet from "react-helmet";
import React, { Component } from "react";
import styled, { cx } from "react-emotion";
import { isEqual } from "lodash";
import { ToastContainer, Slide } from "react-toastify";
import "translations/home";
// eslint-disable-next-line import/no-webpack-loader-syntax
import "!style-loader!css-loader!react-toastify/dist/ReactToastify.css";
// import "!style-loader!css-loader!react-quill/dist/quill.snow.module.css";

import CookieConsentBox from "../CookieConsentBox";
import FlashMessage from "../FlashMessage";
import ExitPopup from "../ExitPopup/ExitPopup";
import Footer from "../Footer";
import NavBar from "../NavBar";

// fix for recursion error, until hemlet v6 is out:
Helmet.prototype.shouldComponentUpdate = function (nextProps) {
  return !isEqual(this.props, nextProps);
};

class Layout extends Component {
  render() {
    const {
      contentClass = "",
      printContent,
      footerContentLight,
      logoLink,
      showMenu,
      navCenterLogo,
      navbarCenterLogoOnMobile,
      footerHideOnMobile = false,
      triggerPageView = false,
      hideCookieConsent = false,
      canonicalHref = `https://www.kitchenadvisor.de${window.location.pathname}`,
      showMeta = true,
      showFooter = true,
    } = this.props;

    return (
      <Provider layout={this}>
        <div className={this.props.className}>
          <FlashMessage />
          <ToastContainer
            position="top-center"
            autoClose={2000}
            hideProgressBar
            transition={Slide}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
          />

          <ExitPopup showExitPopup={this.props.showExitPopup} />
          {printContent}

          <Helmet>
            <html data-touch={isMobile() ? "touch" : "no-touch"} />
            {showMeta && <title>{t("home:meta-title")}</title>}
            {showMeta && <meta property="og:title" content={t("home:meta-title")} />}
            {showMeta && <meta name="description" content={t("home:meta-description")} />}
            <link rel="canonical" href={canonicalHref} />
            <script
              type="text/javascript"
              src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
              async
            />
          </Helmet>

          <div className="t-flex t-min-h-screen t-flex-col">
            <NavBar
              logoLink={logoLink}
              showMenu={showMenu}
              typeCenterLogoOnMobile={navbarCenterLogoOnMobile}
              typeCenterLogoWithSlogan={navCenterLogo}
            />

            <div className={cx("t-flex-1", contentClass)}>{this.props.children}</div>
            {showFooter && (
              <div className={footerHideOnMobile ? "t-hidden sm:t-block" : ""}>
                <Footer light={footerContentLight} />
              </div>
            )}
          </div>

          {!hideCookieConsent && <CookieConsentBox />}
          {triggerPageView && <GoogleTagManager />}
        </div>
      </Provider>
    );
  }
}

export default Layout;
